<div class="w-full cursor-pointer" (click)="selectMethod($event)">
    <div class="grid grid-cols-4 gap-2">
        <div class="col-span-2">
            <h3 class="font-bold">Debit/Credit Card</h3>
        </div>
        <div class="col-span-2">
            <div class="w-full align-middle inline-flex justify-start gap-4">
                <img
                  *ngFor="let cardType of cardSchemas; let i = index"
                  class="card-types"
                  [src]="cardType.imageName"
                  [alt]="cardType.cardName"
                  [ngClass]="['eft-banks', i>3 ? 'invisible lg:visible' : '']"
                />
            </div>
        </div>
    </div>
    <div class="mt-2 grid grid-cols-5 gap-1">
        <p class="col-span-4 subtext mt-2">Pay using your debit/credit card</p>
        <div class="col-span-1">
            <mat-icon class="cursor-pointer float-right" (click)="toggleListView()">info</mat-icon>
        </div>
    </div>
</div>
